<template>
  <div style="padding-left: 1.75rem">
    <div class="col2_head">
      <router-link :to="'/'" class="breadcrumb_home">Acasă /</router-link>
      {{ $route.name }}
      <div class="subHeadTitle">
        {{
          getProcedureTypes[$route.params.procedureType]
            ? getProcedureTypes[$route.params.procedureType].name
            : ""
        }}
        /
        {{
          centralization
            ? centralization.identifier + " - " + centralization.name
            : ""
        }}
      </div>
    </div>
    <template>
      <template v-if="PERMISIONS.list">
        <table-parent
          :reloadCount="reloadTable"
          :tableHead="tableHead"
          :prepareFn="prepareData"
          :apiModule="tableModule"
          apiModuleName="VERBAL_PROCESS"
          :searchModule="searchModule"
          :tableMinimizeHead="true"
          :tableSpread="true"
          :apiModuleOptions="{ specialActions: { 1: 'showSubTableSlot' } }"
          @Btn2="editItem"
          @Btn3="deleteItem"
          @Btn6="openAddress"
          @Btn7="openActions"
          @Btn8="checkApproved"
          @Btn14="viewPdf"
          @Btn42="requestApprove"
          @Btn43="revertSigningFailed"
          @totalRecords="(x) => (totalRecords = x)"
        >
          <template #subitem="{ row }">
            <VerbalProcessProviders
              :verbalProcessId="row.id"
            ></VerbalProcessProviders>
          </template>
        </table-parent>
      </template>
      <template v-else>
        <h3 style="display: flex; flex-direction: column; align-items: center">
          <span style="font-size: 4rem">
            <i class="fas fa-exclamation-triangle"></i>
          </span>
          Acces interzis
        </h3>
      </template>
    </template>
  </div>
</template>

<script>
import PermisionsMixin from "../mixins/verbalProcessPermMixin.js";
import updateRoleStatus from "../mixins/updateUserRoleStatus.js";
import { VERBAL_PROCESS, GET_PAAP_CENTRALIZATION } from "../api.js";
import DialogModal from "@/components/DialogModal";
import TableParent from "@/components/TableParent";
import { mapMutations, mapGetters } from "vuex";
import VerbalProcessProviders from "@/components/VerbalProcessProviders";
import VerbalProcess from "@/components/VerbalProcess";
import AssignmentActions from "@/components/AssignmentActions";
import { OfferEvaluationResult } from "@/common/types/offer-evaluation-result.type";
export default {
  name: "Achizitii",
  $Title() {
    return `ConectX - ${this.$route.name}`;
  },

  mixins: [PermisionsMixin, updateRoleStatus],
  components: {
    TableParent,
    VerbalProcessProviders,
  },

  data() {
    return {
      centralization: null,
      tableHead: [
        {
          title: "Data procesului verbal",
          queryKey: "verbalProcessDate",
          bottomHead: {
            quikFiltre: "date",
          },
        },
        {
          title: "Modalitatea de solicitare",
          queryKey: "requestModality",
          bottomHead: {
            quikFiltre: true,
          },
        },

        {
          title: "Modalitatea de primire",
          queryKey: "receiveModality",
          bottomHead: {
            quikFiltre: true,
          },
        },
        {
          title: "Criteriul de atribuire",
          queryKey: "attributionCriteria",
          bottomHead: {
            quikFiltre: true,
          },
        },
        {
          spacer: true,
          minimize: 1,
          fixed: {
            right: true,
          },
          queryKey: "status",
          bottomHead: {
            quikFiltre: "assignmentDocumentStatus",
          },
        },
      ],
      tableModule: (x, y) =>
        VERBAL_PROCESS.get(
          x,
          y,
          `eq=paapCentralizationId,${this.$route.params.centralization}`,
        ),

      searchModule: (x, y, _, query) => {
        let filter = `eq=paapCentralizationId,${this.$route.params.centralization}`;

        if (query) {
          filter += `&${query}`;
        }

        return VERBAL_PROCESS.get(x, y, filter);
      },
      totalRecords: 0,
      reloadTable: 0,
    };
  },
  methods: {
    ...mapMutations(["setReferenceIdForPreview"]),

    reload() {
      this.reloadTable++;
    },

    openAddress(item) {
      window.open(item.conectxAddressUrl, "_blank");
    },
    revertSigningFailed(item) {
      if (!Number.isInteger(item?.id)) {
        return;
      }

      this.setLoad(true);
      VERBAL_PROCESS.revertSigningFailed(item.id)
        .then((res) => {
          if (this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
            this.$toastr.s("Procesul verbal a revenit în starea de draft.");
          } else {
            this.$toastr.w(res.response || res.message || "A apărut o eroare.");
          }
        })
        .catch((error) => {
          console.error(error);
          this.$toastr.e("A apărut o eroare.");
        })
        .finally(() => {
          this.reload();
          this.setLoad();
        });
    },
    prepareData(row) {
      const preparation = [
        this.toDate(row.verbalProcessDate) || "",
        row.requestModality || "",
        row.receiveModality || "",
        row.attributionCriteria || "",
        {
          draft: {
            border: "left",
            icon: "far fa-clock",
            css: "padding: 0.5rem;color: #f2da07;font-size: 2rem;",
            tooltip: "Draft",
          },
          generated: {
            border: "left",
            icon: "fas fa-pencil",
            css: "padding: 0.5rem;color: #569a36;font-size: 2rem;",
            tooltip: "Generat",
          },
          waiting_approve: {
            border: "left",
            icon: "fas fa-clock",
            css: "padding: 0.5rem;color: #f2da07;font-size: 2rem;",
            tooltip: "Așteptare aprobare",
          },
          signing_failed: {
            border: "left",
            icon: "fas fa-exclamation-triangle",
            css: "padding: 0.5rem;color: #ec4a4a;font-size: 2rem;",
            tooltip: "Semnare eșuată",
          },
          rejected: {
            border: "left",
            icon: "fas fa-times-circle",
            css: "padding: 0.5rem;color: #ec4a4a;font-size: 2rem;",
            tooltip: "Respins",
          },
          approved: {
            border: "left",
            icon: "fas fa-clipboard-check",
            css: "padding: 0.5rem;color: #569a36;font-size: 2rem;",
            tooltip: "Aprobat",
          },
        }[row.status] || "-",
      ];

      const x = this.PERMISIONS;

      const prepareBtn = [];
      if (row.status == "approved" && !row.assignmentDocuments?.length) {
        prepareBtn.push([
          7,
          "Crează achiziție",
          ["fas fa-gears", "font-size:2.2rem; color:green;"],
        ]);
      } else if (!row.assignmentDocuments?.length) {
        prepareBtn.push([
          -1,
          "Indisponibil crearea achiziție până la aprobarea PV",
          [
            "fas fa-gears",
            "font-size:2.2rem; color:green; opacity: 0.5; cursor: initial",
          ],
        ]);
      }

      prepareBtn.push(14);

      if (
        !["approved", "waiting_approve", "signing_failed"].includes(row.status)
      ) {
        prepareBtn.push(2);
      }

      if (row.status == "draft" || row.status == "rejected") {
        prepareBtn.push([
          42,
          "Trimite spre semnare",
          ["fas fa-signal-stream", "font-size:2.2rem;color:#39f;"],
        ]);
      }

      if (row.status == "waiting_approve") {
        prepareBtn.push([
          6,
          "Deschide lucrarea",
          ["fas fa-book", "font-size:2.2rem;color:#39f;"],
        ]);
      }

      if (row.status != "approved" && row.status != "waiting_approve") {
        prepareBtn.push(3);
      }

      prepareBtn.push([1, "Furnizori"]);

      if (row.status == "waiting_approve" && x.edit === true) {
        prepareBtn.push([
          8,
          "Verifică aprobare",
          ["fas fa-sync", "font-size:2.2rem; color:#F2994A;"],
        ]);
      }

      if (row.status == "signing_failed" && x.edit === true) {
        prepareBtn.push([
          43,
          "Revenire din semnare eșuată",
          ["fas fa-redo", "font-size:2.2rem;color:#39f;"],
        ]);
      }

      if (prepareBtn.length) {
        preparation.push([prepareBtn]);
      }

      return Object.assign(preparation, {
        _Data: row,
      });
    },

    viewPdf(data) {
      this.setReferenceIdForPreview({
        data: {
          id: data.id,
        },
        origin: "VERBAL_PROCESS_PDF",
      });
    },

    requestApprove(data) {
      const error = (msg) => {
        this.$toastr.e(msg || "Eroare semanre.");
        this.reload();
        this.setLoad();
      };

      this.setSafeLoad(12000);
      VERBAL_PROCESS.requestApprove(data.id)
        .then((res) => {
          if (this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
            window.open(res.data.result.url, "_blank");
            this.reload();
            this.setLoad();
          } else {
            error(res.response);
          }
        })
        .catch(error);
    },

    openActions(item) {
      const error = (msg) => {
        this.$toastr.e(msg);
        this.setLoad();
      };

      VERBAL_PROCESS.getOne(item.id)
        .then((res) => {
          if (this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
            const verbalProcessData = res.data;
            this.$modal.show(
              DialogModal,
              {
                target: "ActiuniAchizitie",
                title: "Acțiuni achiziții",
                inputs: [
                  {
                    id: "assignmentActions",
                    type: "component",
                    component: AssignmentActions,
                    errReason: "",
                    componentProps: {
                      verbalProcess: JSON.parse(
                        JSON.stringify(verbalProcessData),
                      ),
                      centralization: JSON.parse(
                        JSON.stringify(this.centralization),
                      ),
                    },
                  },
                ],
                closeBtnText: "Anulează",
                button: {
                  disabled: true,
                },
                customClass: "fullWidth",
              },
              {
                name: "ActiuniAchizitie",
                adaptive: true,
                width: "650px",
                height: "570px",
              },
            );
          } else {
            error();
          }
        })
        .catch((err) => {
          error(err.message);
        });
    },

    editItem(item) {
      const error = (msg) => {
        this.$toastr.e(msg || "Salvarea achiziției a eșuat.");
        this.setLoad();
      };

      this.setLoad(true);

      VERBAL_PROCESS.getOne(item.id)
        .then((res) => {
          if (this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
            const verbalProcessData = res.data;
            this.clearFields(verbalProcessData, [
              "assignmentDocuments",
              "conectxAddressUrl",
              "conectxAddressUuid",
              "institution",
              "paapCentralization",
              "registrationDate",
              "registrationDatetime",
              "registrationNumber",
            ]);

            verbalProcessData.memberRole = verbalProcessData.memberRole.flatMap(
              (e) => {
                return {
                  ...e,
                  id: e.id ?? this.makeid(6),
                  _userId: e.user.id,
                  label:
                    this.readUserObject(e.user) +
                    (e.department?.name ? ` — ${e.department?.name}` : "") +
                    (e.role ? ` — ${this.changeRoleView(e.role)}` : ""),
                };
              },
            );

            verbalProcessData.verbalProcessInstitutionProvider =
              verbalProcessData.verbalProcessInstitutionProvider.map((el) => ({
                ...el,
                institutionProviderName: el.institutionProvider.name,
                institutionProviderCui: el.institutionProvider.cui,
                totalValueWithTva: Number(el.totalValueWithTva),
                totalValueWithoutTva: Number(el.totalValueWithoutTva),
              }));

            this.$modal.show(
              DialogModal,
              {
                target: "EDIT_PV",
                title: "Editare proces verbal",
                inputs: [
                  {
                    id: "pv",
                    type: "component",
                    component: VerbalProcess,
                    componentProps: {
                      initial: JSON.parse(JSON.stringify(verbalProcessData)),
                    },
                  },
                ],

                acceptFinish: (data) => {
                  const pv = data.pv;

                  const offers = pv.verbalProcessInstitutionProvider || [];
                  if (offers.some((o) => !o.evaluationResult)) {
                    this.$toastr.w(
                      "Rezultatul evaluării trebuie completat pentru toate ofertele.",
                    );
                    return false;
                  }
                  const winners = offers.filter(
                    (o) => o.evaluationResult === OfferEvaluationResult.WINNER,
                  ).length;
                  const allNonCompliant = offers.every(
                    (o) =>
                      o.evaluationResult ===
                      OfferEvaluationResult.NON_COMPLIANT,
                  );
                  if (winners !== 1 && !allNonCompliant) {
                    this.$toastr.w(
                      "Trebuie să existe un ofertant câștigător, sau toți ofertanții să fie neconformi.",
                    );
                    return false;
                  }

                  this.clearFields(verbalProcessData, [
                    "assignmentDocuments",
                    "conectxAddressUrl",
                    "conectxAddressUuid",
                    "institution",
                    "paapCentralization",
                    "registrationDate",
                    "registrationDatetime",
                    "registrationNumber",
                  ]);

                  delete pv.assignmentDocuments;
                  delete pv.conectxAddressUrl;
                  delete pv.conectxAddressUuid;
                  delete pv.registrationDate;
                  delete pv.registrationDatetime
                  delete pv.registrationNumber;

                  const changedFields = this.getEdited(verbalProcessData, {
                    ...pv,
                    verbalProcessDate: new Date(
                      pv.verbalProcessDate,
                    ).toISOString(),
                  });

                  if (changedFields.verbalProcessInstitutionProvider) {
                    const original =
                      verbalProcessData.verbalProcessInstitutionProvider;
                    const updated = pv.verbalProcessInstitutionProvider;

                    changedFields.verbalProcessInstitutionProvider = updated
                      .map((item) => {
                        const orig = original.find((o) => o.id === item.id);
                        if (!orig) return item;
                        const diff = this.getEdited(orig, item);
                        if (diff.annexes) {
                          diff.annexes = diff.annexes.filter((a) => a.base64);
                          if (!diff.annexes.length) delete diff.annexes;
                        }
                        if (!Object.keys(diff).length) return null;
                        diff.id = item.id;
                        return diff;
                      })
                      .filter(Boolean);

                    if (
                      !changedFields.verbalProcessInstitutionProvider.length
                    ) {
                      delete changedFields.verbalProcessInstitutionProvider;
                    }
                  }

                  if (changedFields.memberRole) {
                    const updated = changedFields.memberRole;

                    changedFields.memberRole = updated.map((item) => {
                      return {
                        id: item.id,
                        role: item.role,
                        user: {
                          uuid: item.user.uuid,
                          id: item.user.id,
                          first_name: item.user.first_name,
                          last_name: item.user.last_name,
                        },
                      };
                    });
                  }

                  if (!Object.keys(changedFields).length) {
                    this.$toastr.w("Nu au fost găsite modificări.");
                    return false;
                  }

                  for (const key in changedFields) {
                    if (!changedFields[key]) {
                      this.$toastr.w("Nu au fost completate toate secțiunile.");
                      return false;
                    }

                    if (
                      key === "departments" &&
                      changedFields[key].length === 0
                    ) {
                      this.$toastr.w("Nu a fost selectat nici un departament.");
                      return false;
                    }

                    if (key == "memberRole") {
                      if (changedFields[key].length === 0) {
                        this.$toastr.w(
                          "Nu au fost completate toate secțiunile.",
                        );
                        return false;
                      }
                    }

                    if (key === "verbalProcessInstitutionProvider") {
                      for (let i = 0; i < changedFields[key].length; i++) {
                        const provider = changedFields[key][i];
                        if (
                          provider.institutionProviderCui === "" ||
                          provider.totalValueWithoutTva === 0 ||
                          provider.totalValueWithTva === 0 ||
                          (Array.isArray(provider.annexes) &&
                            provider.annexes.length) === 0
                        ) {
                          this.$toastr.w(
                            "Nu au fost completate toate datele furnizorului.",
                          );
                          return false;
                        }
                      }
                    }
                  }

                  data.pv = changedFields;

                  return true;
                },

                closeBtnText: "Anulează",
                button: {
                  type: 2,
                  value: "Modifică",
                  handler: (data) => {
                    const error = (msg) => {
                      let errorMsg = msg;
                      if (Array.isArray(msg)) {
                        errorMsg = msg
                          .map((m, i) =>
                            typeof m === "string"
                              ? `Oferta ${i + 1} ` +
                                m.replace(
                                  /^verbalProcessInstitutionProvider\.\d+\./,
                                  "",
                                )
                              : m,
                          )
                          .join("\n");
                      }
                      this.$toastr.e(
                        errorMsg || "Modificarea procesului verbal a eșuat.",
                      );
                      this.reload();
                      this.setLoad();
                      this.editItem(item);
                    };

                    this.setLoad(true);

                    VERBAL_PROCESS.edit(item.id, {
                      ...data.pv,
                    })
                      .then((res) => {
                        if (
                          this.checkHttpStatusCode(res?.meta?.HttpStatusCode)
                        ) {
                          this.$toastr.s("Procesul verbal a fost modificat.");
                          this.reload();
                          this.setLoad();
                        } else {
                          if (this.isObject(res?.response)) {
                            error(res?.response?.message);
                          } else {
                            error(res?.response);
                          }
                        }
                      })
                      .catch(error);
                  },
                },
                customClass: "verbal-process-edit",
              },
              {
                name: "EDIT_PV",
                adaptive: true,
                width: "1200px",
                height: "100%",
              },
            );
          } else {
            error();
          }
        })
        .catch((err) => {
          error(err.message);
        });

      this.setLoad();
    },

    deleteItem(item) {
      if (!Number.isInteger(item?.id)) {
        return;
      }

      this.$modal.show(
        DialogModal,
        {
          target: "DeletePV",
          title: "Șterge procesul verbal",
          inputs: [],
          closeBtnText: "Anulează",
          button: {
            type: 3,
            value: "Șterge",
            handler: () => {
              const error = (msg) => {
                this.$toastr.e(msg || "Procesul verbal nu a fost șters.");
                this.reload();
                this.setLoad();
              };

              this.setLoad(true);
              VERBAL_PROCESS.delete(item.id)
                .then((res) => {
                  if (this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
                    this.$toastr.s("Procesul verbal a fost șters.");
                    this.reload();
                    this.setLoad();
                  } else {
                    error(res.response);
                  }
                })
                .catch(error);
            },
          },
        },
        {
          name: "DeletePV",
          adaptive: true,
          width: "650",
          height: "400",
        },
      );
    },

    checkApproved(item) {
      this.setLoad(true);
      VERBAL_PROCESS.checkApproved(item.id)
        .then((res) => {
          if (this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
            this.reload();
            this.$toastr.s("Starea procesului verbal fost modificată");
          } else {
            this.$toastr.w(res.response || "A apărut o eroare.");
            this.reload();
          }
        })
        .catch(() => {
          this.$toastr.e("A apărut o eroare.");
        });

      this.setLoad();
    },
  },

  computed: {
    ...mapGetters(["getProcedureTypes"]),
  },
  created() {
    if (!this.PERMISIONS.list) {
      return;
    }

    const canViewButtonsColumn = ["approve", "edit", "delete"];

    this.updateRoleStatus();
    if (this.checkParamsInObj(this.PERMISIONS, canViewButtonsColumn)) {
      this.tableHead.push({
        spacer: true,
        minimize: 1,
        fixed: {
          right: true,
        },
        bottomHead: {
          quikFiltre: "clear",
        },
      });
    }

    GET_PAAP_CENTRALIZATION(this.$route.params.centralization).then((res) => {
      this.centralization = res.data;
      const path = this.$route.path;
      const val = path.slice(0, path.lastIndexOf("/"));

      this.$root.$emit("select-item", val.slice(0, val.lastIndexOf("/")));
    });
  },
};
</script>
<style>
.verbal-process-edit {
  max-width: 100% !important;
  max-height: 100% !important;
}
</style>
